import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../../redux/auth/AuthSlice";
import { apiPost } from "../../Services/Services";
import { ENDPOINTS } from "../../Services/Endpoints";
import "./Login.css";
function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({ email: "", password: "" });

  const validateForm = () => {
    const trimmedEmail = email.trim();
    const nextErrors = { email: "", password: "" };

    if (!trimmedEmail) {
      nextErrors.email = "Email is required";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(trimmedEmail)) {
        nextErrors.email = "Please enter a valid email address";
      }
    }

    if (!password) {
      nextErrors.password = "Password is required";
    }

    setErrors(nextErrors);
    return { isValid: !nextErrors.email && !nextErrors.password, trimmedEmail };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { isValid, trimmedEmail } = validateForm();
    if (!isValid) {
      return;
    }

    try {
      setIsSubmitting(true);
      const result = await apiPost(
        ENDPOINTS.auth.login,
        { email: trimmedEmail, password },
        {},
        {
          showSuccessToast: true,
          useApiSuccessMessage: true,
        }
      );

      const payload = result?.data || {};

      dispatch(
        loginSuccess({
          user: payload?.user || null,
          access_token:
            payload?.accessToken || payload?.access_token || payload?.token || null,
          refresh_token: payload?.refreshToken || payload?.refresh_token || null,
          role: payload?.role || payload?.user?.role || "ADMIN",
          permissions: payload?.permissions || payload?.user?.permissions || [],
        })
      );
      navigate("/dashboard");
    } catch (error) {
      // Error toast is already handled by api service.
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleforgot = () => {
    navigate("/forgot");
  };

  const handleregister = () => {
    navigate("/register");
  };

  return (
    <div className="login-page">
      <div className="login-bg" />
      <div className="glow-vein glow-vein-1" />
      <div className="glow-vein glow-vein-2" />

      <div className="login-card">
        <div className="login-header">
          <h1 className="login-title">Welcome Back!</h1>
          <p className="login-subtitle">Login to your account</p>
        </div>

        <form onSubmit={handleSubmit}>
          {/* Email */}
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <div className="input-wrapper">
              <input
                className="form-input"
                // data-invalid={Boolean(errors.email)}
                type="email"
                placeholder="Enter your registered email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (errors.email) {
                    setErrors((prev) => ({ ...prev, email: "" }));
                  }
                }}
              />
            </div>
            {errors.email && <p className="field-error-text">{errors.email}</p>}
          </div>

          {/* Password */}
          <div className="form-group">
            <label className="form-label">Password</label>
            <div className="input-wrapper">
              <input
                className="form-input password-input"
                // data-invalid={Boolean(errors.password)}
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (errors.password) {
                    setErrors((prev) => ({ ...prev, password: "" }));
                  }
                }}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                aria-label="Toggle password visibility"
              >
                {showPassword ? (
                  /* Eye-off icon */
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94" />
                    <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19" />
                    <line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                ) : (
                  /* Eye icon */
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>
            {errors.password && <p className="field-error-text">{errors.password}</p>}
          </div>

          {/* Forgot password */}
          <div onClick={handleforgot} className="forgot-row">
            <span style={{ cursor: "pointer" }} className="forgot-link">Forgot Password?</span>
          </div>

          {/* Submit */}
          <button className="login-btn" type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Logging in..." : "Log In"}
          </button>
        </form>
      </div>
    </div>
  );
}


export default Login;